import React, { useState } from "react";
import { axiosRequest } from "../../api";
import { ADMINURL, baseURL } from "../../constant";
import Cookies from "universal-cookie";

function SubmitTicket() {
    const cookies = new Cookies();
    const checkLogin = cookies.get("islogin");
    const userEmail = cookies.get("userEmail");

    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [subject, setSubject] = useState("");
    const [department, setDepartment] = useState("1");
    const [jobId, setJobId] = useState("");
    const [ticketMessage, setTicketMessage] = useState("");
    const [file, setFile] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    const isLoggedIn = checkLogin === true || checkLogin === "true";

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage("");
        setSuccessMessage("");
        setLoading(true);

        const formData = new FormData();
        formData.append("name", name);
        formData.append("email", email);
        formData.append("phone", phone);
        formData.append("subject", subject);
        formData.append("department", department);
        formData.append("jobId", jobId);
        formData.append("message", ticketMessage);
        if (file) {
            formData.append("file", file);
        }

        try {
            const response = await axiosRequest.post(`${baseURL}/submitGuestTicket`, formData, {
                headers: { "content-type": "multipart/form-data" },
            });

            if (response.data.success === true) {
                setName("");
                setEmail("");
                setPhone("");
                setSubject("");
                setDepartment("1");
                setJobId("");
                setTicketMessage("");
                setFile(null);
                if (e.target && e.target.reset) {
                    e.target.reset();
                }
                setSuccessMessage(response.data.message);
            } else {
                setErrorMessage(response.data.message || "Unable to submit ticket.");
            }
        } catch (error) {
            setErrorMessage(error.response?.data?.message || "Unable to submit ticket. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <section className="inner-page section-themebg">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h3>Submit A Ticket</h3>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section-padding">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-sm-12 col-12">
                            <div className="quotebox">
                                {isLoggedIn ? (
                                    <>
                                        <h4 className="mb-3">New Service Ticket</h4>
                                        <p>You are logged in. Please create your ticket from your dashboard. Our team will follow up from there.</p>
                                        <a
                                            className="btn btn-dark rounded-0"
                                            href={`${ADMINURL}login?email=${userEmail}&login=1`}
                                        >
                                            Go to Dashboard
                                        </a>
                                    </>
                                ) : (
                                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                                        <div className="row">
                                            <div className="col-12 mb-4">
                                                <h4 className="mb-1">New Service Ticket</h4>
                                                <span>Submit this form and our team will contact you manually.</span>
                                            </div>

                                            <div className="col-md-6 col-sm-12 col-12">
                                                <div className="form-group">
                                                    <label htmlFor="name">Full Name</label>
                                                    <input
                                                        type="text"
                                                        id="name"
                                                        className="form-control"
                                                        value={name}
                                                        onChange={(e) => setName(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-sm-12 col-12">
                                                <div className="form-group">
                                                    <label htmlFor="email">Email Address</label>
                                                    <input
                                                        type="email"
                                                        id="email"
                                                        className="form-control"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12 col-sm-12 col-12">
                                                <div className="form-group">
                                                    <label htmlFor="phone">Phone (optional)</label>
                                                    <input
                                                        type="text"
                                                        id="phone"
                                                        className="form-control"
                                                        value={phone}
                                                        onChange={(e) => setPhone(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12 col-sm-12 col-12">
                                                <div className="form-group">
                                                    <label htmlFor="subject">Subject</label>
                                                    <input
                                                        type="text"
                                                        id="subject"
                                                        className="form-control"
                                                        value={subject}
                                                        onChange={(e) => setSubject(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12 col-sm-12 col-12">
                                                <div className="form-group">
                                                    <label htmlFor="department">Department</label>
                                                    <select
                                                        id="department"
                                                        name="department"
                                                        className="form-control"
                                                        value={department}
                                                        onChange={(e) => setDepartment(e.target.value)}
                                                    >
                                                        <option value="1">IT Support</option>
                                                        <option value="2">Sales and Customer Service</option>
                                                        <option value="3">Management</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12 col-sm-12 col-12">
                                                <div className="form-group">
                                                    <label htmlFor="jobId">Job Id (Optional)</label>
                                                    <input
                                                        type="text"
                                                        id="jobId"
                                                        className="form-control"
                                                        value={jobId}
                                                        onChange={(e) => setJobId(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12 col-sm-12 col-12">
                                                <div className="form-group">
                                                    <label htmlFor="message">Message</label>
                                                    <textarea
                                                        id="message"
                                                        className="form-control"
                                                        rows="5"
                                                        value={ticketMessage}
                                                        onChange={(e) => setTicketMessage(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12 col-sm-12 col-12">
                                                <div className="form-group">
                                                    <label htmlFor="file">Upload File</label>
                                                    <input
                                                        type="file"
                                                        id="file"
                                                        className="form-control"
                                                        onChange={(e) => setFile(e.target.files[0] || null)}
                                                    />
                                                    <p className="dropbox-info">Accepted file formats: PDF, TXT, DOC, DOCX</p>
                                                </div>
                                            </div>

                                            {loading ? (
                                                <div id="loading">
                                                    <div id="loader"></div>
                                                </div>
                                            ) : (
                                                " "
                                            )}

                                            <div className="pt-2 col-12">
                                                <button className="btn btn-dark rounded-0" type="submit" disabled={loading}>
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                )}
                                <br />
                                <div className="message error">{errorMessage ? <p>{errorMessage}</p> : null}</div>
                                <div className="message success">{successMessage ? <p>{successMessage}</p> : null}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default SubmitTicket;
